import type { EngrEngineeringDTO } from '@holoview/dao-gen/generated';

import { transmute, type FieldSpec } from '@/shared/mapping';

import type { SolutionListItemDto } from '../dto/solution.dto';
import { normalizeSolutionType } from '@/shared/enums/solution-type';

function toStringArray(value: unknown): string[] {
  if (Array.isArray(value)) return value.map(item => String(item ?? '').trim()).filter(Boolean);
  if (typeof value !== 'string' || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed.map(item => String(item ?? '').trim()).filter(Boolean) : [];
  } catch {
    return [value.trim()];
  }
}

const SOLUTION_LIST_FIELDS: FieldSpec[] = [
  { key: 'id', defaultVal: 0, transform: value => Number(value ?? 0) || 0 },
  { key: 'name', defaultVal: '', transform: value => String(value ?? '').trim() },
  { key: 'status', defaultVal: '', transform: value => String(value ?? '').trim() },
  { key: 'seriesId', from: 'series_id', defaultVal: null, transform: value => (value == null ? null : String(value).trim()) },
  { key: 'caseId', from: 'case_maindata_id', defaultVal: 0, transform: value => Number(value ?? 0) || 0 },
  { key: 'updatedAt', from: 'updatedAt', defaultVal: '', transform: value => String(value ?? '').trim() },
  { key: 'solutionType', from: 'type', transform: normalizeSolutionType },
  { key: 'planSetupAi', from: 'plan_setup_ai', defaultVal: [], transform: toStringArray },
  { key: 'planSetupHolo', from: 'plan_setup_holo', defaultVal: [], transform: toStringArray },
  { key: 'planSetupMdps', from: 'plan_setup_mdps', defaultVal: [], transform: toStringArray },
];

export class SolutionListMapper {
  static toListItem(row: EngrEngineeringDTO): SolutionListItemDto {
    return transmute<SolutionListItemDto>(row, SOLUTION_LIST_FIELDS);
  }

  static toList(items: EngrEngineeringDTO[]): SolutionListItemDto[] {
    return (Array.isArray(items) ? items : [])
      .map(item => SolutionListMapper.toListItem(item))
      .filter(item => item.id > 0);
  }
}
